import React from 'react'
import { CFLink, CFView, Text } from 'components'

export default ({ address, phoneNumber, email }) => (
  <CFView column>
    {address && (
      <CFView row w="100%">
        <CFView w="9rem" mb="2rem">
          <Text heading h4 dark>
            Address
          </Text>
        </CFView>
        <CFLink href="https://goo.gl/maps/mpMvzKmx1N22">
          <Text heading h4 dark>
            {address}
          </Text>
        </CFLink>
      </CFView>
    )}
    {phoneNumber && (
      <CFView row w="100%" mb="2rem">
        <CFView w="9rem">
          <Text heading h4 dark>
            Phone
          </Text>
        </CFView>
        <Text heading h4 dark>
          {phoneNumber}
        </Text>
      </CFView>
    )}
    {email && (
      <CFView row w="100%">
        <CFView w="9rem">
          <Text heading h4 dark>
            Email
          </Text>
        </CFView>
        <CFLink href={`mailto:${email}`}>
          <Text heading h4 dark>
            {email}
          </Text>
        </CFLink>
      </CFView>
    )}
  </CFView>
)
